export enum DevelopmentEvent {
  PUSH = 'PUSH',
  CREATE_BRANCH = 'CREATE_BRANCH',
  CREATE_PULL_REQUEST = 'CREATE_PULL_REQUEST',
  MERGE_PULL_REQUEST = 'MERGE_PULL_REQUEST',
}

export type DevelopmentEventVO = DevelopmentEvent
